// extracted by mini-css-extract-plugin
export var blue = "MinorCTA-module--blue--4e08a";
export var brightBlue = "MinorCTA-module--brightBlue--dd747";
export var copy = "MinorCTA-module--copy--fe657";
export var dark = "MinorCTA-module--dark--c3495";
export var darkBlue = "MinorCTA-module--darkBlue--d3b67";
export var darkGray = "MinorCTA-module--darkGray--1c067";
export var headline = "MinorCTA-module--headline--c37d8";
export var lightGray = "MinorCTA-module--lightGray--6e655";
export var minorCTA = "MinorCTA-module--minorCTA--3c780";
export var offWhite = "MinorCTA-module--offWhite--7b81f";
export var seaGreen = "MinorCTA-module--seaGreen--7db28";
export var softWhite = "MinorCTA-module--softWhite--496f3";
export var white = "MinorCTA-module--white--a18bb";